import BaseSpinWrapper from 'components/atoms/base-spin-wrapper';
import { memo, type FC } from 'react';
import StatCard from 'components/molecules/stat-card';

import s from './styles.module.scss';
import { useButtons } from './use-buttons';

const OverviewDashboardStatusCountFilter: FC = () => {
  const { buttons, isLoading } = useButtons();

  return (
    <BaseSpinWrapper spinning={isLoading}>
      <div className={s.wrapper}>
        {buttons.map(({ active, bgColor, count, status, label, onClick }) => {
          return (
            <StatCard
              key={label}
              active={active}
              bgColor={bgColor}
              count={count}
              label={label}
              onClick={onClick}
              showCrown={false}
              dataStatus={status}
              titleClassNames={s.title}
              countClassNames={s.count}
              btnClassNames={s.item}
              bgClassNames={s.bg}
            />
          );
        })}
      </div>
    </BaseSpinWrapper>
  );
};
export default memo(OverviewDashboardStatusCountFilter);
